import type {State} from 'src/reducers';

import type {
  OrgTemplate,
  OrgTemplates,
  OrgTemplatesFilters,
} from 'src/types/scheduler/org-templates';


export const selectOrgTemplates = (state: State): OrgTemplates => {
  return state.scheduler.orgTemplates.data || [];
};

export const selectOrgTemplatesFilters = (
  state: State,
): OrgTemplatesFilters => {
  return state.scheduler.orgTemplates.filters || {};
};

export const selectOrgTemplateById = (
  state: State,
  templateId: string,
): OrgTemplate => {
  // @ts-expect-error - TS2339 - Property 'orgTemplates' does not exist on type 'DefaultRootState'.
  return (state.scheduler.orgTemplates.data || []).find(
    (template: OrgTemplate) => template.id === templateId,
  );
};
